import React from 'react';

import useCart from 'modules/cart/util/use-cart';
import {OrderProps, translatedOrderProps} from 'modules/orders/types';
import Form from 'shared/migration-components/form';
import useFormInputs from 'shared/migration-components/form/util';
import {useNavigate} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import styled from 'styled-components';

const AddDocument: React.FC = () => {
  const {cart, addDocument} = useCart();
  const {getInput} = useFormInputs();
  const navigate = useNavigate();
  const formContext = useForm();

  const handleValidate = ({document}: Pick<OrderProps, 'document'>) => {
    if (!document)
      return formContext.setError('document', {
        message: 'Cpf inválido',
      });

    addDocument(document);
    navigate(-1);
  };

  return (
    <Container>
      <Form<OrderProps>
        {...{formContext}}
        defaultValues={{document: cart?.document}}
        inputs={[
          getInput({
            label: 'Cpf',
            name: 'document',
            placeholder: 'Informe o cpf',
            mask: 'cpf',
          }),
        ]}
        translationKey={translatedOrderProps}
        extraButtons={(data) => [
          {title: 'CONFIRMAR', onClick: () => handleValidate(data)},
        ]}
      />
    </Container>
  );
};

export default AddDocument;

const Container = styled.div`
  padding-top: 15px;
`;
